export enum ADMIN_PANEL_TAB {
  USER = 'User',
  JOB_OPENING = 'Job Opening',
  ASSESSMENT = 'Assessment',
}
